import { ChangeDetectionStrategy,Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from "@angular/core";
import {IrbEditorComponent} from "@irb/irb-editors/irb-editors.com";
import {
    IPortfolioResultCheckValidationConfiguration,
    IPortfolioResultDialogData,
    IPortfolioResultLotRebalanceSummary,
    IPortfolioResultRequest,
    IPortfolioResultResponse,
    IPortfolioResultSECRebal,
    IPortfolioResultSecurity,
    IPortfolioResultUnheldSecurity,
    IPortfolioResultUnheldSecurityDetailRequest,
    IPortfolioResultUpdateShareQtyConfiguration,
    SecurityTradeActionNote
} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {ComPrOrdersGridLayoutService} from "@irb/irb-editors/editor-portfolio-result/com-pr-orders/com-pr-orders.grid-layout.service";
import {
    PrOrdersService,
    PrSpreadTradeService,
    PrSwapExchangeService,
    PrUnheldSecurityService,
    PrValidationService
} from "@irb/irb-editors/editor-portfolio-result/services";
import {CalltoactionService} from "@irb/irb-common/components/calltoaction/calltoaction.service";
import {IrbAppEvents, IrbEditorsEvents} from "@irb-common/events";
import {IrbEditorPortfolioResultService} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.service";
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {DialogComponent} from '@irb-common/components/dialog/dialog.component';
import {SecurityComponentsDialogComponent} from '@irb/irb-editors/editor-security/security-components-dialog/security-components-dialog.component';
import {IAlertDialogData} from '@irb/app.model';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {CellClickedEvent} from "ag-grid-community";
import { JasperSettings, ISortModel } from "@irb/irb-dialogs/dialog-pr-export-pdf/dialog-pr-export-pdf.component";

@Component({ standalone: false,
    selector: "irb-com-pr-orders",
    templateUrl: "./com-pr-orders.component.html",
    styleUrls: ["./com-pr-orders.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPrOrdersComponent extends IrbEditorComponent implements OnInit {
    @ViewChild('unheldSecurityOrderField') unheldSecurityOrderField: any;
    @ViewChild("unheldSecuritySymbolDropdown") unheldSecuritySymbolDropdown: any;
    @ViewChild("unheldAccountDropdown") unheldAccountDropdown: any;
    @ViewChild('comPrOrderTemplate') comPrOrderTemplate: TemplateRef<any>;
    @ViewChild('securityTradeActionNoteTemplate') securityTradeActionNoteTemplate: TemplateRef<any>;
    @ViewChild("dialogPrComOrders") dialogPrComOrders: DialogComponent;

    @Input() pdfExportConfig: JasperSettings;
    @Output() pdfExportConfigChange = new EventEmitter<JasperSettings>();

    _data: IPortfolioResultResponse;
    originalData: IPortfolioResultResponse;
    @Output() change = new EventEmitter<boolean>();
    @Input() isAutomated: boolean;
    grid: any;
    detailGrid: any;
    gridOptions: any;
    frameworkComponents: any;
    gridHeight: string = "100%";
    cellEditInProgress: boolean = false;
    showAllPositions: boolean = false;
    positionsWithOrdersIds: Array<number> = [];
    optionShortTxnTypes = ["SELL_TO_OPEN", "BUY_TO_CLOSE"];
    optionLongTxnTypes = ["SELL_TO_CLOSE", "BUY_TO_OPEN"];
    detailGrids: Array<any> = [];
    isPending: boolean = false;
    isNA: boolean = false;
    unheldSecurityObj: IPortfolioResultUnheldSecurity;
    unheldSecurityOption: IDropdownItem;
    unheldSecurityOrderAmt: string = "0.00";
    unheldSecurityAccountOptions: Array<IDropdownItem>;
    unheldSecurityAccountOption: IDropdownItem;
    addUnheldSecurityDisabled: boolean = true;
    unpackedSecRebalDTOList: Array<IPortfolioResultSECRebal>;
    originalUnpackedSecRebalDTOList: Array<IPortfolioResultSECRebal>;
    comPrOrderTemplateContent: string;
    securityTradeActionNoteTemplateContent: string;
    private refreshAllgrid: boolean = true;
    componentName: any ='portfolioResultSummaryOrders';
    transactionTypes: Array<any> = [
        {value: "SELL", name: "SELL", needDisplay: false},
        {value: "SELL ALL", name: "SELL ALL", needDisplay: false},
        {value: "BUY", name: "BUY", needDisplay: false},
        {value: "NONE", name: "NONE", needDisplay: false},
        {value: "SELL_TO_OPEN", name: "SELL TO OPEN", needDisplay: false},
        {value: "SELL_TO_CLOSE", name: "SELL TO CLOSE", needDisplay: false},
        {value: "BUY_TO_OPEN", name: "BUY TO OPEN", needDisplay: false},
        {value: "BUY_TO_CLOSE", name: "BUY TO CLOSE", needDisplay: false}
    ];
    isUiTest = false;
    popupParent:any;
    ENABLE_FRACTIONAL_SHARES: boolean;
    expandAllEnabled: boolean = true;
    collapseAllEnabled: boolean = false;

    constructor(private gls: ComPrOrdersGridLayoutService,
                private pros: PrOrdersService,
                private prvs: PrValidationService,
                private prsts: PrSpreadTradeService,
                private prses: PrSwapExchangeService,
                private ctas: CalltoactionService,
                private pruhs: PrUnheldSecurityService,
                private prs: IrbEditorPortfolioResultService) {
        super();
        this.ENABLE_FRACTIONAL_SHARES = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_FRACTIONAL_SHARES || false;
        this.popupParent = document.querySelector("body");
        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),
            floatingFilter: false,
            context: {componentParent: this},
            treeData: true,
            getDataPath: (data: IPortfolioResultSECRebal) => {
                const isLot: boolean = data.parentId ? true : false;
                return (isLot) ? [data.parentId.toString(), data.rowId.toString()] : [data.rowId.toString()];
            },
            groupDisplayType: 'custom',
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: this.filterGrid.bind(this),
            onCellEditingStopped: this.onCellEditingStopped.bind(this),
            getRowId: (params: any) => {
                return params.data.rowId;
            },
            onRowGroupOpened: () => {
                this.updateGridHeight();
                this.checkIfAnyExpandedOeCollapsed();
            },
            postSortRows: this.onPostSort.bind(this),
            onCellClicked:  this.onPrOrdersCellClicked.bind(this),
            suppressHorizontalScroll: true
        };

        this.frameworkComponents = this.gls.getFrameworkComponents();
    }

    ngOnInit() {
        super.ngOnInit();
        this.isPending = this.data.rebalStatus === "PENDING";
        this.isNA = this.data.rebalStatus === "NA";
        this.mapPositionsWithOrders();
        this.unpackLots();
        this.unheldSecurityAccountOptions = this.pruhs.populateUnheldSecurityAccountOptions(this.data);
        this.unheldSecurityAccountOption = this.unheldSecurityAccountOptions.length === 1 ? this.unheldSecurityAccountOptions[0] : null;
        this.showAllPositions = this.data.rebalType === "Manual Adj" ? true : this.as.getFromSession("PRD_SHOW_ALL_POSITIONS") || false;
        this.pdfExportConfig.showAllOrder = this.showAllPositions;
        this.pdfExportConfigChange.emit(this.pdfExportConfig);
    }

    onDataLoad() {
        setTimeout(() => { this.update(); });
    }

    update(setRowData?: boolean) {
        if (this.grid && !this.util.compare(this.data, this.originalData)) {     
            const originalIsPending = this.isPending;       
            this.isPending = this.data.rebalStatus === "PENDING";
            this.isNA = this.data.rebalStatus === "NA";

            if(!this.util.compare(this.data.secRebalDTOList, this.originalData.secRebalDTOList) || this.isPending !== originalIsPending) {
                this.mapPositionsWithOrders();

                if (this.refreshAllgrid) {
                    this.unpackLots();
                }

                if (setRowData) {
                    this.grid.api.setGridOption('rowData', this.unpackedSecRebalDTOList);
                } else {
                    if (this.refreshAllgrid) {
                        setTimeout(() => this.grid.api.redrawRows());
                    }
                    this.refreshAllgrid = true;
                }

                this.updateOriginalData();
                setTimeout(() => this.updateGridHeight());
            }
            if (!this.originalData)
                super.onDataLoad();
        } else if (!this.grid) {
            this.updateOriginalData();
        }
    }

    updateOriginalData() {
        this.originalData = this.util.clone(this.data);
        this.originalUnpackedSecRebalDTOList = this.util.clone(this.unpackedSecRebalDTOList);
    }

    onGridReady(params: any) {
        this.grid = params;
        //this.grid.api.sizeColumnsToFit();
        this.updateGridHeight();
    }

    onCellEditingStopped(event: any) {
        const isLot: boolean = event.data.parentId ? true : false;

        switch (event.colDef.field) {
            case "txnType":
                (isLot) ? this.onApplyEditTxnTypeToChild(event) : this.onApplyEditTxnTypeToParent(event);
                this.mapPositionsWithOrders();
                break;
            case "txnAmt":
                (isLot) ? this.onApplyEditTxnAmtToChild(event) : this.onApplyEditTxnAmtToParent(event);
                break;
            case "txnShares":
                this.onApplyEditTxnSharesToParent(event);
                break;
        }
        this.data.revertUserEdits = false;
    }

    updateGridHeight() {
        const tr = this.grid.api.getDisplayedRowCount();

        if (tr === 0) {
            this.gridHeight = "100px";
        } else if (tr > 20) {
            this.gridHeight = "600px";
        } else {
            const p = 63 + (tr * 30);
            this.gridHeight = p + "px";
        }
    }

    showPositionsWithNoOrders() {
        this.showAllPositions = true;
        this.grid.api.onFilterChanged();
        this.updateGridHeight();
        this.as.setToSession("PRD_SHOW_ALL_POSITIONS", this.showAllPositions);
        this.pdfExportConfig.showAllOrder = this.showAllPositions;
        this.pdfExportConfigChange.emit(this.pdfExportConfig);
    }

    hidePositionsWithNoOrders() {
        this.showAllPositions = false;
        this.grid.api.onFilterChanged();
        this.updateGridHeight();
        this.as.setToSession("PRD_SHOW_ALL_POSITIONS", this.showAllPositions);
        this.pdfExportConfig.showAllOrder = this.showAllPositions;
        this.pdfExportConfigChange.emit(this.pdfExportConfig);
    }

    filterGrid(node: any) {
        if (this.showAllPositions) {
            return true;
        } else {
            return this.positionsWithOrdersIds.indexOf(node.data.rebalSecId) !== -1;
        }
    }

    packLots() {
        const parents = this.unpackedSecRebalDTOList.filter((x: IPortfolioResultSECRebal) => !x.parentId);
        const lots = this.unpackedSecRebalDTOList.filter((x: IPortfolioResultSECRebal) => x.parentId);

        parents.forEach((parent: IPortfolioResultSECRebal) => {
            parent.lotRebalanceSummaryDTOList = [];

            lots.forEach((lot: IPortfolioResultSECRebal) => {
                if(parent.rowId === lot.parentId) {
                    parent.lotRebalanceSummaryDTOList.push(lot);
                }
            });
        });

        this.data.secRebalDTOList = this.util.clone(parents);
    }

    unpackLots() {
        const a: Array<IPortfolioResultSECRebal> = [];

        this.data.secRebalDTOList.forEach((item: IPortfolioResultSECRebal) => {
            if(item.lotRebalanceSummaryDTOList?.length > 0) {
                item.lotRebalanceSummaryDTOList.forEach((lot: IPortfolioResultLotRebalanceSummary) => {
                    a.push(lot as IPortfolioResultSECRebal);
                });
            }
        });

        this.unpackedSecRebalDTOList = this.data.secRebalDTOList.concat(a);
    }

    mapPositionsWithOrders() {
        this.positionsWithOrdersIds = [];

        this.getPositionsWithOrders((items: Array<IPortfolioResultSECRebal>) => {
            for (let k = 0; k < items.length; k++) {
                const secSymbol = items[k].secSymbol;
                const isOption = items[k].secType === "OPTION";
                const accountNum = items[k].accountNum;

                this.positionsWithOrdersIds.push(items[k].rebalSecId);

                if (isOption) {
                    const parentSymbol = secSymbol.split(" ")[0];

                    this.getUnderlyingWithPositionForOption(parentSymbol, accountNum, (_items: Array<IPortfolioResultSECRebal>) => {
                        for (let i = 0; i < _items.length; i++) {
                            this.positionsWithOrdersIds.push(_items[i].rebalSecId);
                        }

                        this.getOptionsForUnderlying(parentSymbol, accountNum, (_items: Array<IPortfolioResultSECRebal>) => {
                            for (let i = 0; i < _items.length; i++) {
                                this.positionsWithOrdersIds.push(_items[i].rebalSecId);
                            }
                        });
                    });
                } else {
                    this.getOptionsForUnderlying(secSymbol, accountNum, (_items: Array<IPortfolioResultSECRebal>) => {
                        for (let i = 0; i < _items.length; i++) {
                            this.positionsWithOrdersIds.push(_items[i].rebalSecId);
                        }
                    });
                }
            }
        });
    }

    getPositionsWithOrders(cbFunc: Function) {
        const a: Array<IPortfolioResultSECRebal> = [];

        this.data.secRebalDTOList.forEach((item: IPortfolioResultSECRebal) => {
            if (item.txnType !== "NONE") {
                a.push(item);
            }
        });

        cbFunc(a);
    }

    getUnderlyingWithPositionForOption(symbol: string, accountNum: string, cbFunc: Function) {
        const a: Array<IPortfolioResultSECRebal> = [];

        this.data.secRebalDTOList.forEach((item: IPortfolioResultSECRebal) => {
            if (item.secSymbol === symbol && item.accountNum === accountNum && item.roundedMktValue !== 0) {
                a.push(item);
            }
        });

        cbFunc(a);
    }

    getOptionsForUnderlying(symbol: string, accountNum: string, cbFunc: Function) {
        const a: Array<IPortfolioResultSECRebal> = [];

        this.data.secRebalDTOList.forEach((item: IPortfolioResultSECRebal) => {
            if (item.secSymbol.match(new RegExp("^" + symbol + " ")) && item.secType === "OPTION" && item.accountNum === accountNum) {
                a.push(item);
            }
        });

        cbFunc(a);
    }

    getTransactionType(value: string) {
       return this.transactionTypes.find((x: any) => x.value === value) || null;
    }
    
    getTransactionTypes(params: any) {
        const parentItem = params.data.parentId ? this.pros.getParentItem(this.unpackedSecRebalDTOList, params.data.parentId) : null;
        const isOption: boolean = params.data.secType === "OPTION";
        const isLot: boolean = params.data.parentId ? true : false;
        const isLotOfOption: boolean = isLot && parentItem ? parentItem.secType === "OPTION" : false;
        const isShortPosition = params.data.mktValue < 0;
        const isUnopenedPosition = params.data.mktValue === 0;
        const buyUnheldSecurity = params.data.buyUnheldSecurity;
        const hasChildren: boolean = (params.data.lotRebalanceSummaryDTOList && params.data.lotRebalanceSummaryDTOList.length > 0) || false;
        const t: Array<any> = [];
        const transactionTypes: Array<any> = this.util.clone(this.transactionTypes);

        transactionTypes.forEach((type: any) => {
            if (isOption) {
                const b = [].concat(isUnopenedPosition ? [this.optionShortTxnTypes[0], this.optionLongTxnTypes[1]] : this.optionLongTxnTypes);
                const a = ["NONE"].concat(isShortPosition ? this.optionShortTxnTypes : b);
                type.needDisplay = a.indexOf(type.value) !== -1;
            } else if (isLotOfOption) {
                const a = ["NONE"].concat(isShortPosition ? this.optionShortTxnTypes : this.optionLongTxnTypes);
                type.needDisplay = a.indexOf(type.value) !== -1;
            } else {
                if (this.optionShortTxnTypes.indexOf(type.value) !== -1 || this.optionLongTxnTypes.indexOf(type.value) !== -1) {
                    type.needDisplay = false;
                } else {
                    if (buyUnheldSecurity === true || (!hasChildren && !isLot)) {
                        //create dropdown values for buyUnheldsecurites
                        //allowed values  : Buy and None
                        if (type.value === "NONE" || type.value === "BUY") {
                            type.needDisplay = true;
                        }
                    } else if (isLot) {
                        //create dropdown values for lot level
                        //allowed values  : sell and None
                        if (type.value === "NONE" || type.value === "SELL") {
                            type.needDisplay = true;
                        }
                    } else if (hasChildren) {
                        if (type.value === "NONE" || type.value === "BUY" || type.value === "SELL ALL" || type.value === "SELL") {
                            type.needDisplay = true;
                        }
                    }
                }
            }

            if (type.needDisplay) {
                t.push(type);
            }
        });

        return t;
    }

    canEditTransactionType(params: any) {
        if (this.data.portfolioDeleted && this.data.rebalStatus === "NA") {
            return false;
        }

        if (this.data.rebalStatus !== "PENDING" && this.data.rebalStatus !== "NA") {
            return false;
        }

        const parentId = params.data.parentId;
        let mktValue = params.data.mktValue;
        let secType = params.data.secType;

        if (secType === "EQ" && mktValue < 0) {
            return false;
        }

        if (parentId) {
            const parentItem = this.pros.getParentItem(this.unpackedSecRebalDTOList, parentId);

            secType = parentItem.secType;
            mktValue = parentItem.mktValue;

            if (secType === "OPTION") {
                return false;
            } else if (secType === "EQ" && mktValue < 0) {
                return false;
            } else if (parentItem.txnType === "BUY") {
                // for a position with buy proposal, its lots txntype should be non editable
                return false;
            }

            return true;
        }

        return true;
    }

    canEditOrderAmount(params: any) {
        if (this.data.portfolioDeleted && this.data.rebalStatus === "NA") {
            return false;
        }

        if (this.data.rebalStatus !== "PENDING" && this.data.rebalStatus !== "NA") {
            return false;
        }

        if (params.data.txnType === "SELL ALL" || params.data.txnType === "NONE") {
            // based on txn type
            return false;
        }

        if (params.data.parentId) {
            const parentItem = this.pros.getParentItem(this.unpackedSecRebalDTOList, params.data.parentId);

            if (parentItem.secType === "OPTION") {
                return false;
            }
        } else {
            if (params.data.secType === "OPTION") {
                return false;
            }
        }

        return true;
    }

    canEditOrderShares(params: any) {
        if(params.data.parentId) {
            return false;
        }

        if (this.data.portfolioDeleted && this.data.rebalStatus === "NA") {
            return false;
        }

        if (this.data.rebalStatus !== "PENDING" && this.data.rebalStatus !== "NA") {
            return false;
        }

        if (params.data.txnType === "SELL ALL" || params.data.txnType === "NONE") {
            // based on txn type
            return false;
        }

        return params.data.secType === "EQ" || params.data.secType === "OPTION" || params.data.secType === "EXTERNAL" || (params.data.secType === "MF" && params.data.txnType !== "BUY");
    }

    onUpdateAfterEditToParent(d: IPortfolioResultSECRebal, params: any) {
        this.pros.calculateSecPenalty(d);
        this.packLots();
        this.refreshAllgrid = false;
        this.change.emit(true);

        setTimeout(() => {
            this.refreshAllgrid = true;
        }, 0); // this.refreshAllgrid should always be reset to true

        const changedRows: Array<any> = [params.node.data];
        const changedNodes: Array<any> = [params.node];

        this.grid.api.forEachNode((n: any) => {
            if (n.data.parentId === params.node.data.rowId) {
                changedRows.push(n.data);
                changedNodes.push(n);
            }
            if (n.data.securityId === params.node.data.securityId) {
                this.checkUpdateWashSaleLotSoldAtLoss(this.data.secRebalDTOList, n.data);
                changedNodes.push(n);
            }
        });

        this.grid.api.redrawRows({rowNodes: changedNodes});
        this.updateOriginalData();
    }

    onUpdateAfterEditToChild(d: IPortfolioResultSECRebal) {
        this.packLots();
        this.refreshAllgrid = false;
        this.change.emit(true);

        setTimeout(() => {
            this.refreshAllgrid = true;
        }, 0); // this.refreshAllgrid should always be reset to true

        if (this.grid && this.grid.api) {
            const mn = this.grid.api.getRowNode(d.parentId);
            const changedRows: Array<any> = [mn.data];
            const changedNodes: Array<any> = [mn];

            this.grid.api.forEachNode((n: any) => {
                if (n.data.parentId === mn.data.rowId) {
                    changedRows.push(n.data);
                    changedNodes.push(n);
                }
                if (n.data.securityId === mn.data.securityId) {
                    this.checkUpdateWashSaleLotSoldAtLoss(this.data.secRebalDTOList, n.data);
                    changedNodes.push(n);
                }
            });
            this.grid.api.redrawRows({rowNodes: changedNodes});
            this.updateOriginalData();
        }
    }

    onCompleteEditTxnTypeToParent(d: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, params: any, isSellType: boolean) {
        this.pros.calculateSecPenalty(d);

        this.prvs.checkValidation({
            data: this.data,
            item: d,
            snapShotItem: snapShotItem,
            validnFor: "sellRestricn",
            onComplete:  (callStack: Array<string>, item: IPortfolioResultSECRebal) => {
                this.prvs.checkValidation({
                    data: this.data,
                    item: item,
                    snapShotItem: snapShotItem,
                    validnFor: "excluded",
                    onComplete: () => {
                        this.onCompleteAfterValidationEditTxnTypeToParent(d, snapShotItem, params, isSellType);
                        this.prvs.completeValidation();
                    },
                    onCancel: () => {
                        this.onUpdateAfterEditToParent(d, params);
                    },
                    callStack: callStack
                } as IPortfolioResultCheckValidationConfiguration);
            },
            onCancel: () => {
                this.onUpdateAfterEditToParent(d, params);
            }
        } as IPortfolioResultCheckValidationConfiguration);
    }

    onCompleteAfterValidationEditTxnTypeToParent(d: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, params: any, isSellType: boolean) {
      const self = this;
      this.pros.setTxnCurrency(d, d.txnCurrency);

        if(isSellType) {
            this.pros.distributeSellInLots(d);
        }

        if (d.secType && ["OTHER", "GROUP"].indexOf(d.secType) === -1) {
            if (d.txnType === "SELL ALL") {
                this.pros.updateShareQty({
                    data: self.data,
                    item: d,
                    snapShotItem: snapShotItem,
                    isShareQtyEdit: false,
                    previousTxnAmt: snapShotItem.txnAmt,
                    editField: "txnAmt",
                    onComplete: () => {
                        this.onUpdateAfterEditToParent(d, params);
                    }
                } as IPortfolioResultUpdateShareQtyConfiguration);

                return;
            } else {
                this.pros.calBasedonPOValChange(this.data, d, true);
            }
        } else {
            this.pros.calBasedonPOValChange(this.data, d);
        }
        this.onUpdateAfterEditToParent(d, params);
    }

    onApplyEditTxnTypeToParent(params: any) {
        const d = params.node.data as IPortfolioResultSECRebal;
        const snapShotItem = this.pros.getParentItem(this.originalUnpackedSecRebalDTOList, d.rowId);
        const isSellType = this.pros.getSellType(d.txnType);
        d.txnTypeEdit = true;

        if (["SELL", "BUY", "NONE", "SELL_TO_OPEN", "SELL_TO_CLOSE", "BUY_TO_OPEN", "BUY_TO_CLOSE", "SELL ALL"].indexOf(d.txnType) !== -1 && snapShotItem.txnType) {
            if (d.txnType !== snapShotItem.txnType) {
                this.pros.resetSecurity(d);
                this.pros.resetSecLots(d);
            }
        }

        this.pros.setIsUserTxnComplete(d);

        if (d.txnCurrency === null) {
            d.txnCurrency = "DOLLARS";
        }

        if (d.txnType === "SELL ALL") {
            d.txnCurrency = "SHARES";

            if (d.txnType !== snapShotItem.txnType) {
                d.txnAmt = d.roundedMktValue;
                this.packLots();
                this.prses.confirmSwapExchangeIntegrity(this.data, d, snapShotItem, () => {
                    this.prsts.confirmSpreadTradeIntegrity(this.data, d, snapShotItem, () => {
                        this.onCompleteEditTxnTypeToParent(d, snapShotItem, params, isSellType);
                    }, () => { this.onUpdateAfterEditToParent(d, params) });
                }, () => { this.onUpdateAfterEditToParent(d, params); });
            }
        } else if (["SELL", "BUY", "NONE", "SELL_TO_OPEN", "SELL_TO_CLOSE", "BUY_TO_OPEN", "BUY_TO_CLOSE"].indexOf(d.txnType) !== -1) {
            if (d.txnType !== snapShotItem.txnType) {
                this.packLots();
                this.prses.confirmSwapExchangeIntegrity(this.data, d, snapShotItem, () => {
                    this.prsts.confirmSpreadTradeIntegrity(this.data, d, snapShotItem, () => {
                        this.onCompleteEditTxnTypeToParent(d, snapShotItem, params, isSellType);
                    }, () => { this.onUpdateAfterEditToParent(d, params) });
                }, () => { this.onUpdateAfterEditToParent(d, params); });
            }
        }
    }

    onApplyEditTxnTypeToChildFF(parentItem: any, parentSnapShotItem: any, d: any) {
      const self = this;
      this.pros.setTxnCurrency(parentItem, parentItem.txnCurrency);

        if (parentItem.secType && ["OTHER", "GROUP"].indexOf(parentItem.secType) === -1) {
            if (parentItem.txnType === "SELL ALL") {
                this.pros.updateShareQty({
                    data: self.data,
                    item: parentItem,
                    snapShotItem: parentItem,
                    isShareQtyEdit: false,
                    previousTxnAmt: parentSnapShotItem.txnAmt,
                    editField: "txnAmt",
                    onComplete: () => {
                        this.onUpdateAfterEditToChild(d);
                    }
                });

                return;
            } else {
                this.pros.calBasedonPOValChange(this.data, parentItem, true);
            }
        } else {
            this.pros.calBasedonPOValChange(this.data, parentItem);
        }

        this.onUpdateAfterEditToChild(d);
    }

    onApplyEditTxnTypeToChild(params: any) {
        const d = params.node.data as IPortfolioResultLotRebalanceSummary;
        const parentItem = this.pros.getParentItem(this.unpackedSecRebalDTOList, d.parentId);
        const parentSnapShotItem = this.pros.getParentItem(this.originalUnpackedSecRebalDTOList, d.parentId);
        const snapShotItem = this.pros.getLotItem(parentSnapShotItem.lotRebalanceSummaryDTOList, d.rowId);

        if (["SELL", "BUY", "NONE", "SELL_TO_OPEN", "SELL_TO_CLOSE", "BUY_TO_OPEN", "BUY_TO_CLOSE", "SELL ALL"].indexOf(d.txnType) !== -1 && snapShotItem.txnType) {
            if (d.txnType !== snapShotItem.txnType) {
                this.pros.resetSecurity(d);
                this.pros.updateLotAndParentSec(this.unpackedSecRebalDTOList, d, () => {
                    this.prvs.checkValidation({
                        data: this.data, 
                        item: parentItem, 
                        snapShotItem: parentSnapShotItem, 
                        validnFor: "sellRestricn",
                        onComplete: () => this.prvs.completeValidation()
                    } as IPortfolioResultCheckValidationConfiguration);
                });
            }
        }

        this.pros.setIsUserTxnComplete(d);

        if (parentItem.txnCurrency === null) {
            parentItem.txnCurrency = "DOLLARS";
        }

        const f = () => {
            const ff = () => {
                this.onApplyEditTxnTypeToChildFF(parentItem, parentSnapShotItem, d);
                this.prvs.completeValidation();
            };

            this.prvs.checkValidation({
                data: this.data, 
                item: parentItem, 
                snapShotItem: parentSnapShotItem, 
                validnFor: "sellRestricn", 
                onComplete: () => {
                    this.prvs.checkValidation({
                        data: this.data, 
                        item: parentItem, 
                        snapShotItem: parentSnapShotItem, 
                        validnFor: "excluded", 
                        onComplete: ff
                    } as IPortfolioResultCheckValidationConfiguration);
                }
            } as IPortfolioResultCheckValidationConfiguration);
        };

        if (parentItem.txnType === "SELL ALL") {
            parentItem.txnCurrency = "SHARES";

            if (parentItem.txnType !== parentSnapShotItem.txnType) {
                parentItem.txnAmt = parentItem.roundedMktValue;

                this.pros.distributeSellInLots(parentItem);
                this.packLots();
                this.prses.confirmSwapExchangeIntegrity(this.data, parentItem, parentSnapShotItem, () => {
                    this.prsts.confirmSpreadTradeIntegrity(this.data, parentItem, parentSnapShotItem, f, () => { this.onUpdateAfterEditToChild(d) });
                }, () => { this.onUpdateAfterEditToChild(d) });
            }
        } else if (["SELL", "BUY", "NONE", "SELL_TO_OPEN", "SELL_TO_CLOSE", "BUY_TO_OPEN", "BUY_TO_CLOSE"].indexOf(d.txnType) !== -1) {
            if (d.txnType !== snapShotItem.txnType) {
                this.packLots();
                this.prses.confirmSwapExchangeIntegrity(this.data, parentItem, parentSnapShotItem, () => {
                    this.prsts.confirmSpreadTradeIntegrity(this.data, parentItem, parentSnapShotItem, f, () => { this.onUpdateAfterEditToChild(d) });
                }, () => { this.onUpdateAfterEditToChild(d) });
            }
        }
    }

    onApplyEditTxnAmtToParent(params: any) {
        const d = params.node.data as IPortfolioResultSECRebal;
        d.txnAmt = params.value;
        const snapShotItem = this.pros.getParentItem(this.originalUnpackedSecRebalDTOList, d.rowId);

        if (d.txnAmt !== snapShotItem.txnAmt) {
            const isOption = d.secType === "OPTION";
            const isSellType = this.pros.getSellType(d.txnType);

            if (d.txnAmt === 0) {
                d.txnType = "NONE";
                this.pros.resetSecurity(d);
                this.pros.resetSecLots(d);
                this.onUpdateAfterEditToParent(d, params);
                this.mapPositionsWithOrders();
            }

            if (typeof d.txnAmt !== "undefined" && typeof snapShotItem.txnAmt !== "undefined") {
                const self = this;
                const f = () => {
                    const ff = () => {
                        if (isSellType) {
                            this.pros.distributeSellInLots(d);
                        }
                        
                        this.pros.setTxnCurrency(d, "DOLLARS");

                        if (d.secType && ["OTHER", "GROUP"].indexOf(d.secType) === -1) {
                            this.pros.updateShareQty({
                                data: self.data,
                                item: d,
                                snapShotItem: snapShotItem,
                                isShareQtyEdit: false,
                                previousTxnAmt: snapShotItem.txnAmt,
                                editField: "txnAmt",
                                onComplete: (isValid: boolean) => {
                                    if (isValid || d.txnAmt == params.value) {
                                        this.onUpdateAfterEditToParent(d, params);
                                    } else {
                                        params.value = d.txnAmt;
                                        this.onApplyEditTxnAmtToParent(params);
                                    }

                                    this.prvs.completeValidation();
                                },
                                checkValidationFunction: (data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, validnFor: string, cbFunc?: any, callStack?: Array<string>) => {
                                    this.prvs.checkValidation({
                                        data: data,
                                        item: item,
                                        snapShotItem: snapShotItem,
                                        validnFor: validnFor,
                                        onComplete: cbFunc,
                                        callStack: callStack,
                                        onCancel: () => {
                                            params.value = snapShotItem.txnAmt;
                                            this.onApplyEditTxnAmtToParent(params);
                                        }
                                    } as IPortfolioResultCheckValidationConfiguration);
                                }
                            });
                        } else {
                            d.txnAmtEdit = !isOption; // Always false if it is options
                            this.pros.calBasedonPOValChange(this.data, d, true);
                            this.onUpdateAfterEditToParent(d, params);
                        }
                    };

                    this.pros.calculateSecPenalty(d);
                    
                    this.prvs.checkValidation({
                        data: this.data, 
                        item: d, 
                        snapShotItem: snapShotItem, 
                        validnFor: "sellOrBuyMin", 
                        onComplete: (callStack: Array<string>, item) => {
                            this.prvs.checkValidation({
                                data: this.data, 
                                item: item, 
                                snapShotItem: snapShotItem, 
                                validnFor: "equityTradeMinimum", 
                                callStack: callStack,
                                onComplete: (callStack: Array<string>) => {
                                    if (d.ccDNSRestriction && d.txnAmt > d.iRblTxnAmt) {
                                        this.prvs.checkValidation({
                                            data: this.data, 
                                            item: d, 
                                            snapShotItem: snapShotItem, 
                                            validnFor: "sellRestricn", 
                                            onComplete: ff, 
                                            onCancel: () => {
                                                this.onUpdateAfterEditToParent(d, params);
                                            },
                                            callStack: callStack
                                        } as IPortfolioResultCheckValidationConfiguration);
                                    } else {
                                        ff();
                                    }
                                },
                                onCancel: () => {
                                    this.onUpdateAfterEditToParent(d, params);
                                }
                            } as IPortfolioResultCheckValidationConfiguration);
                        },
                        onCancel: () => {
                            this.onUpdateAfterEditToParent(d, params);
                        }
                    } as IPortfolioResultCheckValidationConfiguration);
                };

                if (d.txnType === "SELL" && d.txnAmt > d.mktValue) {
                    const dialogData = {} as IPortfolioResultDialogData;
                    dialogData.message = "You cannot sell more than the amount held in an account";
                    dialogData.title = "Sell All";
                    dialogData.dialogFor = "sellAllWrng";
                    dialogData.beforeChangeTxnAmt = snapShotItem.txnAmt;
                    dialogData.beforeChangeTxnType = snapShotItem.txnType;
                    dialogData.beforeChangeTxnShares = snapShotItem.txnShares;
                    dialogData.tradeItem = d;
                    dialogData.onComplete = (() => {
                        if (d.txnAmt !== snapShotItem.txnAmt) {
                            this.packLots();
                            this.prses.confirmSwapExchangeIntegrity(this.data, d, snapShotItem, () => {
                                this.prsts.confirmSpreadTradeIntegrity(this.data, d, snapShotItem, f, () => { this.onUpdateAfterEditToParent(d, params) });
                            }, () => { this.onUpdateAfterEditToParent(d, params) });
                        } else {
                            this.onUpdateAfterEditToParent(d, params);
                        }
                    }).bind(this);
                    dialogData.proceedLabel = "Sell All";
                    dialogData.cancelLabel = "Cancel";
                    this.prvs.displayPfSummryConfDialog(this.data, d, snapShotItem, dialogData);
                    return;
                }

                this.packLots();
                this.prses.confirmSwapExchangeIntegrity(this.data, d, snapShotItem, () => {
                    this.prsts.confirmSpreadTradeIntegrity(this.data, d, snapShotItem, f, () => { this.onUpdateAfterEditToParent(d, params) });
                }, () => { this.onUpdateAfterEditToParent(d, params) });
            }
        }
    }

    onApplyEditTxnAmtToChild(params: any) {
        const self = this;
        let d = params.node.data as IPortfolioResultLotRebalanceSummary;
        d.txnAmt = params.value;
        const parentItem = this.pros.getParentItem(this.unpackedSecRebalDTOList, d.parentId);
        const parentSnapShotItem = this.pros.getParentItem(this.originalUnpackedSecRebalDTOList, d.parentId);
        const snapShotItem = this.pros.getLotItem(parentSnapShotItem.lotRebalanceSummaryDTOList, d.rowId);

        if (d.txnAmt !== snapShotItem.txnAmt) {
            const isOption = false;
            const isSellType = this.pros.getSellType(d.txnType);

            if (d.txnAmt === 0) {
                d.txnType = "NONE";
                this.pros.resetSecurity(d);

                this.pros.updateLotAndParentSec(this.unpackedSecRebalDTOList, d, () => {
                    this.prvs.checkValidation({
                        data: this.data, 
                        item: parentItem, 
                        snapShotItem: parentSnapShotItem, 
                        lotItem: d,
                        lotSnapShotItem: snapShotItem,
                        validnFor: "sellRestricn",
                        onCancel: () => {
                            this.onUpdateAfterEditToChild(d);
                        },
                        onComplete: () => this.prvs.completeValidation()
                    } as IPortfolioResultCheckValidationConfiguration);
                });

                this.onUpdateAfterEditToChild(d);
                this.mapPositionsWithOrders();
            }

            if (typeof d.txnAmt !== "undefined" && typeof snapShotItem.txnAmt !== "undefined") {
                const f = () => {
                    if (isSellType) {
                        this.pros.updateLotAndParentSec(this.unpackedSecRebalDTOList, d, () => {
                            this.prvs.checkValidation({
                                data: this.data, 
                                item: parentItem, 
                                snapShotItem: parentSnapShotItem,
                                lotItem: d,
                                lotSnapShotItem: snapShotItem, 
                                validnFor: "sellRestricn",
                                onCancel: () => {
                                    this.onUpdateAfterEditToChild(d);
                                },
                                onComplete: () => this.prvs.completeValidation()
                            } as IPortfolioResultCheckValidationConfiguration);
                        });
                    }

                    const ff = () => {
                        this.pros.setTxnCurrency(parentItem, "DOLLARS");

                        if (parentItem.secType && ["OTHER", "GROUP"].indexOf(parentItem.secType) === -1) {
                            this.pros.updateShareQty({
                                data: self.data,
                                item: parentItem,
                                snapShotItem: parentSnapShotItem,
                                isShareQtyEdit: false,
                                previousTxnAmt: parentSnapShotItem.txnAmt,
                                editField: "txnAmt",
                                onComplete: (isValid: boolean) => {
                                    if (isValid) {
                                        this.onUpdateAfterEditToChild(d);
                                    } else {
                                        d = this.pros.getLotItem(parentSnapShotItem.lotRebalanceSummaryDTOList, d.rowId);

                                        if(d.txnAmt == params.value) {
                                            this.onUpdateAfterEditToChild(d);
                                        } else {

                                            params.value = d.txnAmt;
                                            this.onApplyEditTxnTypeToChild(params);
                                        }
                                    }

                                    this.prvs.completeValidation();
                                },
                                checkValidationFunction: (data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, validnFor: string, cbFunc?: any, callStack?: Array<string>) => {
                                    this.prvs.checkValidation({
                                        data: data,
                                        item: item,
                                        snapShotItem: parentSnapShotItem,
                                        lotItem: d,
                                        lotSnapShotItem: snapShotItem,
                                        validnFor: validnFor,
                                        onComplete: cbFunc,
                                        callStack: callStack,
                                        onCancel: () => {
                                            params.value = snapShotItem.txnAmt;
                                            this.onApplyEditTxnTypeToChild(params);
                                        }
                                    } as IPortfolioResultCheckValidationConfiguration);
                                },
                                initiatedByLotEdit: true
                            });
                        } else {
                            parentItem.txnAmtEdit = !isOption; // Always false if it is options
                            this.pros.calBasedonPOValChange(this.data, parentItem, true);
                            this.onUpdateAfterEditToChild(d);
                        }
                    };

                    this.prvs.checkValidation({
                        data: this.data, 
                        item: parentItem, 
                        snapShotItem: parentSnapShotItem, 
                        lotItem: d,
                        lotSnapShotItem: snapShotItem,
                        validnFor: "sellOrBuyMin", 
                        onComplete: (callStack: Array<string>) => {
                            this.prvs.checkValidation({
                                data: this.data, 
                                item: parentItem, 
                                snapShotItem: parentSnapShotItem,
                                lotItem: d,
                                lotSnapShotItem: snapShotItem,
                                validnFor: "equityTradeMinimum", 
                                onComplete: (callStack: Array<string>) => {
                                    if (parentItem.ccDNSRestriction && d.txnAmt > d.iRblTxnAmt) {
                                        this.prvs.checkValidation({
                                            data: this.data, 
                                            item: parentItem, 
                                            snapShotItem: parentSnapShotItem, 
                                            lotItem: d,
                                            lotSnapShotItem: snapShotItem,
                                            validnFor: "sellRestricn", 
                                            onComplete: ff, 
                                            callStack: callStack
                                        } as IPortfolioResultCheckValidationConfiguration);
                                    } else {
                                        ff();
                                    }
                                },
                                onCancel: () => {
                                    this.onUpdateAfterEditToChild(d);
                                },
                                callStack: callStack 
                            } as IPortfolioResultCheckValidationConfiguration);
                        },
                        onCancel: () => {
                            this.onUpdateAfterEditToChild(d);
                        }
                    });
                };

                if (d.txnType === "SELL" && d.txnAmt > d.mktValue) {
                    const dialogData = {} as IPortfolioResultDialogData;
                    dialogData.message = "You cannot sell more than the amount held in an account";
                    dialogData.title = "Sell All";
                    dialogData.dialogFor = "sellAllWrng";
                    dialogData.beforeChangeTxnAmt = snapShotItem.txnAmt;
                    dialogData.beforeChangeTxnType = snapShotItem.txnType;
                    dialogData.beforeChangeTxnShares = snapShotItem.txnShares;
                    dialogData.tradeItem = parentItem;
                    dialogData.onComplete = (() => {
                        if (d.txnAmt !== snapShotItem.txnAmt) {
                            this.packLots();
                            this.prses.confirmSwapExchangeIntegrity(this.data, parentItem, parentSnapShotItem, () => {
                                this.prsts.confirmSpreadTradeIntegrity(this.data, parentItem, parentSnapShotItem, f, () => { this.onUpdateAfterEditToChild(d) });
                            }, () => { this.onUpdateAfterEditToChild(d) });
                        } else {
                            this.onUpdateAfterEditToChild(d);
                        }
                    }).bind(this);
                    dialogData.proceedLabel = "Sell All";
                    dialogData.cancelLabel = "Cancel";
                    this.prvs.displayPfSummryConfDialog(this.data, d, snapShotItem, dialogData);
                    return;
                }

                this.packLots();
                this.prses.confirmSwapExchangeIntegrity(this.data, parentItem, parentSnapShotItem, () => {
                    this.prsts.confirmSpreadTradeIntegrity(this.data, parentItem, parentSnapShotItem, f, () => { this.onUpdateAfterEditToChild(d) });
                }, () => { this.onUpdateAfterEditToChild(d) });
            }
        }
    }

    onApplyEditTxnSharesToParent(params: any) {
      const self = this;
      const d = params.node.data as IPortfolioResultSECRebal;
        d.txnShares = params.value;
        const snapShotItem = this.pros.getParentItem(this.originalUnpackedSecRebalDTOList, d.rowId);

        if (d.txnShares !== snapShotItem.txnShares) {
            if (!d.txnShares || isNaN(d.txnShares)) {
                d.txnShares = 0;
            }

            const shareQtyEdit = d.txnShares !== snapShotItem.txnShares;

            if (d.txnShares === 0) {
                d.txnType = "NONE";
                this.pros.resetSecurity(d);
                this.pros.resetSecLots(d);
                this.onUpdateAfterEditToParent(d, params);
                this.mapPositionsWithOrders();
            }

            const isOptionClose = d.txnType === "BUY_TO_CLOSE" || d.txnType === "SELL_TO_CLOSE";
            const isShortPosition = d.mktValue < 0;
            const f = () => {
                if (d.secType !== "OTHER" && d.secType !== "GROUP") {
                    if (shareQtyEdit) {
                        this.pros.updateShareQty({
                            data: self.data,
                            item: d,
                            snapShotItem: snapShotItem,
                            isShareQtyEdit: true,
                            previousTxnAmt: snapShotItem.txnAmt,
                            editField: "txnShares",
                            onComplete: () => {
                                this.onUpdateAfterEditToParent(d, params);
                                this.prvs.completeValidation();
                            },
                            checkValidationFunction: (data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, validnFor: string, cbFunc?: any, callStack?: Array<string>) => {
                                this.packLots();
                                this.prvs.checkValidation({
                                    data: data, 
                                    item: item, 
                                    snapShotItem: snapShotItem, 
                                    validnFor: validnFor, 
                                    onComplete: cbFunc, 
                                    callStack: callStack,
                                    onCancel: () => {
                                        this.onUpdateAfterEditToParent(d, params);
                                    }
                                } as IPortfolioResultCheckValidationConfiguration);
                            }
                        });

                        this.pros.setTxnCurrency(d, "SHARES");
                    }
                }
            };

            if (isOptionClose) {
                if ((isShortPosition && d.txnShares > -1 * d.currentShares) || (!isShortPosition && d.txnShares > d.currentShares)) {
                    const dialogData = {} as IPortfolioResultDialogData;
                    dialogData.message = "You can not close more than you own in the account";
                    dialogData.title = "Sell/Buy to Cover warning";
                    dialogData.dialogFor = "closeOptionWrng";
                    dialogData.beforeChangeTxnType = snapShotItem.txnType;
                    dialogData.beforeChangeTxnShares = snapShotItem.txnShares;
                    dialogData.tradeItem = d;
                    this.prvs.displayPfSummryDialog(this.data, dialogData, () => {
                        this.onUpdateAfterEditToParent(d, params);
                    });
                    return;
                }
            } else if (d.txnType === "SELL" && d.txnShares > d.currentShares) {
                const dialogData = {} as IPortfolioResultDialogData;
                dialogData.message = "You cannot sell more than the shares held in an account";
                dialogData.title = "Sell All";
                dialogData.dialogFor = "sellAllWrng";
                dialogData.beforeChangeTxnAmt = snapShotItem.txnAmt;
                dialogData.beforeChangeTxnType = snapShotItem.txnType;
                dialogData.beforeChangeTxnShares = snapShotItem.txnShares;
                dialogData.tradeItem = d;
                dialogData.onComplete = (() => {
                    if (d.txnShares !== snapShotItem.txnShares) {
                        this.packLots();
                        this.prses.confirmSwapExchangeIntegrity(this.data, d, snapShotItem, () => {
                            this.prsts.confirmSpreadTradeIntegrity(this.data, d, snapShotItem, f, () => { this.onUpdateAfterEditToParent(d, params) });
                        }, () => { this.onUpdateAfterEditToParent(d, params) });
                    } else {
                        this.onUpdateAfterEditToParent(d, params);
                    }
                }).bind(this);
                dialogData.proceedLabel = "Sell All";
                dialogData.cancelLabel = "Cancel";
                this.prvs.displayPfSummryConfDialog(this.data, d, snapShotItem, dialogData);
                return;
            }

            this.packLots();
            this.prses.confirmSwapExchangeIntegrity(this.data, d, snapShotItem, () => {
                this.prsts.confirmSpreadTradeIntegrity(this.data, d, snapShotItem, f, () => { this.onUpdateAfterEditToParent(d, params) });
            }, () => { this.onUpdateAfterEditToParent(d, params) });
        }
    }
    onApplyEditTxnSharesToParentDialogDataOnComplete() {}

    cancelCallToAction() {
        this.ctas.remove();
    }

    clearAllOrders() {
        this.ctas.remove();

        this.data.secRebalDTOList.forEach((item: IPortfolioResultSECRebal) => {
            item.txnType = "NONE";
            this.pros.resetSecurity(item);
            this.pros.resetSecLots(item);
            this.pros.calBasedonPOValChange(this.data, item, true);
        });

        this.data.userRebalStatus = 'NA';
        this.change.emit(true);
        this.update();
    }

    clearAllUserEdits() {
        this.ctas.remove();
        this.data.revertUserEdits = true;
        
        const req = {
            method: "revertAllUsersEdit",
            rebalId: this.data.rebalId,
            portfolioId: this.data.portfolioId,
            revertUserEdits: this.data.revertUserEdits
        } as IPortfolioResultRequest;

        this.as.fireEvent(IrbEditorsEvents.SAVE_START);
        this.prs.getPortfolioResult(req).subscribe((resp: IPortfolioResultResponse) => {
            this.data.secRebalDTOList = resp.secRebalDTOList;
            this.data.pfSecRebalDTOList = resp.pfSecRebalDTOList;

            this.data.secRebalDTOList.forEach((item: IPortfolioResultSECRebal) => {
                this.pros.calBasedonPOValChange(this.data, item);
            });

            this.change.emit(true);
            this.update();
            this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT);
        }, () => this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT));
    }

    populateUnheldSymbols(searchString: string) {
        if (searchString && searchString.length > 0) {
            this.unheldSecuritySymbolDropdown.set((this.data.secDropDownDTOList || [])
                .filter((security: IPortfolioResultSecurity) => security.securitySymbol &&
                    security.securitySymbol.toUpperCase().startsWith(searchString.toUpperCase()))
                .map((security: IPortfolioResultSecurity) => ({
                    name: security.securitySymbol,
                    value: security
                })));
        }
    }

    populateUnheldAccounts(searchStr: any) {
        this.unheldAccountDropdown.set(DropdownFilterComponent.getFilteredList(searchStr, this.unheldSecurityAccountOptions));
    }

    enableDisableButton() {
        this.addUnheldSecurityDisabled = true;
        if (this.unheldSecurityOrderField && this.unheldSecurityOrderField.inputControl.valid && 
            this.unheldSecurityOrderAmt && this.unheldSecurityOrderAmt !== "0.00" && this.unheldSecurityAccountOption
            && this.unheldSecurityOption) {
            this.addUnheldSecurityDisabled = false;
        }if(this.unheldSecurityOrderAmt === "0.00"){
            this.addUnheldSecurityDisabled = true;
        }
    }
    setUnheldSecurity() {
        let c = 0;
        const isShareQtyEdit = false;
        let hasSecurityOrderAmt = false;
        this.addUnheldSecurityDisabled = true;
        if (this.unheldSecurityOrderField && this.unheldSecurityOrderField.inputControl.valid && 
            this.unheldSecurityOrderAmt && this.unheldSecurityOrderAmt !== "0.00" ) {
            if (typeof this.unheldSecurityOrderAmt === 'string')
                c = parseFloat(this.unheldSecurityOrderAmt.replace("$", ""));
            else
                c = parseFloat(this.unheldSecurityOrderAmt);
            hasSecurityOrderAmt = true;
            //this.addUnheldSecurityDisabled = true;
        }
        const hasSecurity = this.unheldSecurityOption ? true : false;
    
        const hasSecurityAccount = this.unheldSecurityAccountOption ? true : false;
    
        if (hasSecurity && hasSecurityOrderAmt && hasSecurityAccount) {
            const req = {} as IPortfolioResultUnheldSecurityDetailRequest;
            req.accountNum = this.unheldSecurityAccountOption.value;
            req.securityId = this.unheldSecurityOption.value.securityId;
            req.secType = this.unheldSecurityOption.value.securityType;
            req.txnAmt = c;
            req.txnCurrency = isShareQtyEdit ? "SHARES" : "DOLLARS";
    
            const r = this.pruhs.getUnheldSecDetailsRequest(req, this.data);
    
            this.prs.getPortfolioResult(r).subscribe((resp: IPortfolioResultResponse) => {
                this.unheldSecurityObj = resp.unheldSecurity;
                this.addUnheldSecurityDisabled = false;
                if (this.unheldSecurityObj && this.unheldSecurityObj.rowId)
                    this.unheldSecurityObj.rowId = this.unheldSecurityObj.rowId + new Date().getTime(); // EF avoid duplicate when add same sec for diff acct
            });
        }
    }
    clearUnheldSecurity(){
        this.unheldSecurityOption = null;
        this.addUnheldSecurityDisabled = true;
        this.unheldSecuritySymbolDropdown.set(this.unheldSecurityOption || []);
    }

    closeUnheldSecurityPopover() {
        this.ctas.remove();
        this.unheldSecurityOption = null;
        this.unheldSecurityOrderAmt = "$0.00";
        this.unheldSecurityAccountOption = this.unheldSecurityAccountOptions.length === 1 ? this.unheldSecurityAccountOptions[0] : null;
    }

    addUnheldSecurity() {
        this.pruhs.addSecurityToOrders(this.data, this.unheldSecurityObj, (success: boolean, item?: IPortfolioResultSECRebal) => {
            if (success) {
                this.pruhs.addSecurityToAllocations(this.data, this.unheldSecurityObj, () => {
                    this.pros.calBasedonPOValChange(this.data, item);
                    const snapShotItem = this.util.clone(item);
                    this.pros.resetSecurity(snapShotItem);
                    
                    this.change.emit(true);
                    this.update(true);
                    this.setSelectedNewRow(item);
                });
            }
        });

        this.closeUnheldSecurityPopover();
    }

    setSelectedNewRow(item: any) {
        if (this.grid && this.grid.api && item) {
            this.grid.api.forEachNode((node: any) => {
                if (node.data.rebalSecId === item.rebalSecId && node.data.securityId === item.securityId) {
                    node.setSelected(true);
                }
            });
        }
    }

    getSecurityDescription(params: any) {
        if(params.data.secType === "OPTION") {
            return null;
        }
        
        const item = params.data.parentId ? this.pros.getParentItem(this.data.secRebalDTOList, params.data.parentId) : params.data;
        const d: string = item.secSymbol + "<br/>" + item.secDescription;
        this.comPrOrderTemplateContent = d;
        return this.comPrOrderTemplate;
    }

    getSecurityTradeActionNoteTemplate(n: Array<SecurityTradeActionNote>) {
        this.securityTradeActionNoteTemplateContent = "";
        let c = 1;

        n.forEach((note: SecurityTradeActionNote) => {
            let s = (c++ == n.length) ? "<div>" : "<div class='block'>";
            this.securityTradeActionNoteTemplateContent += s + note.description + "</div>";
        });

        return (n.length > 0) ? this.securityTradeActionNoteTemplate : null;
    }

    onPostSort(rowNodes: Array<any>) { 
        const optionOrders: any = {};

        //remove option orders, and create a map of options using account number and parent symbol
        for(let i = 0; i < rowNodes.length; i++) {
            if(rowNodes[i].data.secType === "OPTION") {
                const accountNum = rowNodes[i].data.accountNum;
                const parentSymbol = rowNodes[i].data.secSymbol.split(" ")[0];

                if(typeof optionOrders[accountNum] === "undefined") {
                    optionOrders[accountNum] = [];
                }

                if(typeof optionOrders[accountNum][parentSymbol] === "undefined") {
                    optionOrders[accountNum][parentSymbol] = [];
                }

                optionOrders[accountNum][parentSymbol].push(rowNodes.splice(i--,1)[0]);
            }
        }

        //insert option orders after their parent symbol
        Object.keys(optionOrders).forEach((accountNum: string) => {
            Object.keys(optionOrders[accountNum]).forEach((parentSymbol: string) => {
                for(let i = 0; i < rowNodes.length; i++) {
                    if(rowNodes[i].data.secSymbol === parentSymbol && rowNodes[i].data.accountNum === accountNum) {
                        rowNodes.splice(i + 1, 0, ...optionOrders[accountNum][parentSymbol]);
                        delete optionOrders[accountNum][parentSymbol];
                        break;
                    }
                }
            });            
        });
        
        //if no parent symbol is found, reinsert
        Object.keys(optionOrders).forEach((accountNum: string) => {
            Object.keys(optionOrders[accountNum]).forEach((parentSymbol: string) => {
                rowNodes.push(...optionOrders[accountNum][parentSymbol]); 
            });
        });
    }

    showGroupComponents(params: any) {
        if (params.data.rebalCompSecurityDTOList.length === 0) {
            this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                dTitle: "Alert",
                msg: "There are no component securities associated with this group.",
                dProceedBtnLabel: "Ok",
                dType: "ERROR"
            } as IAlertDialogData);
            return;
        }

        const config = this.dialogPrComOrders.getDefaultConfig();
        config.minHeight = "200px";
        config.height = "auto";
        config.width = "600px";
        config.data = {
            groupSecurity: params.data.secSymbol,
            rebalCompSecurityDTOList: params.data.rebalCompSecurityDTOList
        };
        this.dialogPrComOrders.open(SecurityComponentsDialogComponent, config);
    }

    resetGridColumns() {
        localStorage.removeItem(this.componentName);
        this.grid.api.resetColumnState();
        //this.grid.api.sizeColumnsToFit();
    }
    
    onPrOrdersCellClicked(event: CellClickedEvent) {
        if(event.column.getColId() === 'accountNum' ) {
            if(event.node.isExpandable() && event.node.expanded) {
                event.node.setExpanded(false);
            } else if (event.node.isExpandable() && !event.node.expanded) {
                event.node.setExpanded(true);
            }
            this.updateGridHeight();
        }
    }
  checkUpdateWashSaleLotSoldAtLoss(secRebalDTOList: Array<IPortfolioResultSECRebal>, item: any) {
    const securityId = item.securityId;
    let washSaleLotSoldAtLoss = false;
    let lotSoldInLossFound = false;
    let lotPurchasedLessThan30DaysFound = false;
    const currentDate = new Date().getTime();
    let secRebalDTOtoUpdate:IPortfolioResultSECRebal = null;
    if (secRebalDTOList && secRebalDTOList.length > 0) {
      for (let i = 0; i < secRebalDTOList.length; i++) {
        let secRebalDTO = secRebalDTOList[i];
        if (secRebalDTO.securityId === securityId) { // security that was just proposed to sell
            if (secRebalDTO.lotRebalanceSummaryDTOList) {
              for (let j = 0; j < secRebalDTO.lotRebalanceSummaryDTOList.length; j++) {
                let lotRebalanceSummaryDTO = secRebalDTO.lotRebalanceSummaryDTOList[j];
                const lotPurchaseDate = new Date(lotRebalanceSummaryDTO.lotPurchaseDate).getTime();
                if (secRebalDTO.accountNum === item.accountNum && secRebalDTO.accountType === 'T') {
                  secRebalDTOtoUpdate = secRebalDTO;
                  if (!lotSoldInLossFound
                    // && (currentDate - lotPurchaseDate > 1000 * 3600 * 24 * 30) // bought more than 30 days ago
                   &&  lotRebalanceSummaryDTO.txnAmt > 0 // sold
                   && lotRebalanceSummaryDTO.realzdGainLoss < 0 ) { // at a loss
                    lotSoldInLossFound = true;
                  }
                }
                if (!lotPurchasedLessThan30DaysFound && lotRebalanceSummaryDTO.lotPurchaseDate) {

                  if (currentDate - lotPurchaseDate <= 1000 * 3600 * 24 * 30 //bought within 30 days
                    && lotRebalanceSummaryDTO.txnAmt < lotRebalanceSummaryDTO.roundedMktValue //  and not fully sold
                  ) {
                    lotPurchasedLessThan30DaysFound = true;
                  }
                }
              }
            }
        }

      }
      washSaleLotSoldAtLoss = lotPurchasedLessThan30DaysFound && lotSoldInLossFound;
      //assign washSale to all order lines for the security
      if (secRebalDTOtoUpdate) {
        secRebalDTOtoUpdate.washSaleLotSoldAtLoss = washSaleLotSoldAtLoss;
      }
      if (item.txnType?.includes('SELL')) {
        item.washSaleLotSoldAtLoss = washSaleLotSoldAtLoss;
      } else {
        item.washSaleLotSoldAtLoss = false;
      }
    }
  }

    expandAllOrders() {
        this.grid.api.expandAll();
        this.expandAllEnabled = false;
        this.collapseAllEnabled = true;
        this.updateGridHeight();
    }

    collapseAllOrders() {
        this.grid.api.collapseAll();
        this.expandAllEnabled = true;
        this.collapseAllEnabled = false;
        this.updateGridHeight();
    }

    checkIfAnyExpandedOeCollapsed() {
        let expandableExists = false,
          collapsableExists = false;
        this.grid.api.forEachNodeAfterFilter((node: any) => {
            if (node.isExpandable()) {
                if (node.expanded)
                    expandableExists = true;
                else
                    collapsableExists = true;
            }
        });
        this.collapseAllEnabled = expandableExists;
        this.expandAllEnabled = collapsableExists;
    }

    onShowHidePositions() {
        (!this.showAllPositions) ? this.showPositionsWithNoOrders() : this.hidePositionsWithNoOrders();
    }

    onColumnVisible(_ev: any) {
        let sortModel = this.grid?.api.getColumnState().filter((col:any) => col.sort !== null);

        if(sortModel?.length > 0) {
            this.pdfExportConfig.orderSortModel = [];

            sortModel.forEach((m: any) => {
                this.pdfExportConfig.orderSortModel.push({
                    sort: m.colId,
                    order: m.sort
                } as ISortModel);
            });

            this.pdfExportConfigChange.emit(this.pdfExportConfig);
        }
    }

    hasUserEdits(): boolean {
        return this.pros.hasUserEdits;
    }

    hasOrders(): boolean {
        return this.pros.hasOrders;
    }
}
